import { render, staticRenderFns } from "./ComplaintMainSearchDetail.vue?vue&type=template&id=c2687a70&"
import script from "./ComplaintMainSearchDetail.vue?vue&type=script&lang=js&"
export * from "./ComplaintMainSearchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports